module.exports = __webpack_public_path__ + "static/logo-departures@2x-119b5d3b083e053a637658c3e7e00065.png";